import { Pipe, PipeTransform } from '@angular/core';
import { differenceInMinutes, formatDistance } from 'date-fns';

@Pipe({
  name: 'timeDiff'
})
export class TimeDiffPipe implements PipeTransform {
  transform(value: any): string {
    const now = Date.now();
    const date = new Date(value);
    return differenceInMinutes(now, date) > 0
      ? `${formatDistance(Date.now(), new Date(value))} ago`
      : 'now';
  }
}
